import queryString from 'query-string';
import * as actions from '../actions';
import {Map} from 'immutable';

export default function kitIconSetSearch(state = null, action) {
  const locationQuery = queryString.parse(location.search);

  let nextState = state || Map({
    query: (locationQuery.q || ''), // eslint-disable-line id-length
    results: null,
  });

  if (action.type === actions.SEARCH_FOR_ICON_NEW_QUERY) {
    nextState = nextState.set('query', action.query);
  }

  if (action.type === actions.SEARCH_FOR_ICON_EMPTY_QUERY) {
    nextState = nextState.set('query', '').set('results', null);
  }

  if (action.type === actions.SEARCH_FOR_ICON_RESULTS) {
    nextState = nextState.set('results', Map({
      iconSetHits: action.iconSetHits,
      iconSetCounts: action.iconSetCounts,
      iconHits: action.iconHits,
      iconHighlights: action.iconHighlights,
      count: action.count,
    }));
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/reducers/kitIconSetSearch.js